import { Component, OnInit, Renderer2 } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../state/app.state';
import { selectCruce } from '../../state/selectors/cruce.selectors';
import { selectBtnRapido } from '../../state/selectors/btnRapido.selectors';
import { Cruce, BtnRapido, TipoVehiculo ,SubtipoCruce} from '../../models';
import { addCruceClasificacion, addCruceObservacion, clearCruce } from '../../state/actions/cruce.actions';
import { addBtnRapidoClasificacion, addBtnRapidoObservacion, postBtnRapido } from '../../state/actions/btnRapido.actions';
import { postCruce } from '../../state/actions/cruce.actions';
import { TYPE_CRUCE, TYPE_BTNS, TYPE_CRUCE_PADRE, TYPE_PERMISO } from '../../utils/enum';
import { loadTipoVehiculo } from 'src/app/state/actions/tipoVehiculo.actions';
import { selectTipoVehiculo } from 'src/app/state/selectors/tipoVehiculo.selectors';
import { selectUser } from 'src/app/state/selectors/user.selectors';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { selectPermisos } from 'src/app/state/selectors/caseta.selectors';

import {NgxUiLoaderService} from 'ngx-ui-loader';
import { SolicitudesService } from 'src/app/services/solicitudes.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-clasificacion-vehicular',
  templateUrl: './clasificacion-vehicular.component.html',
  styleUrls: ['./clasificacion-vehicular.component.scss']
})
export class ClasificacionVehicularComponent implements OnInit {

  cruce: any = null;
  user: any = null;
  btnRapido: any = null;
  tiposVehiculo$: Observable<TipoVehiculo> = new Observable<TipoVehiculo>();
  toRedirect: boolean = true
  //variables caravaa
  isCaravana:any=false
  activeCaravana = false;
  countCaravana: number=0;
  //variables para no emitidos y cancelados
  btnTemp: any
  id_cat_observacion: number = 0;
  //permisos
  permisos:any = [];
  constructor(
    private store: Store<AppState>,
    private router: Router,
    private toastr: ToastrService,
    private renderer:Renderer2,
    private solicitudesService: SolicitudesService,
    private ngxService:NgxUiLoaderService
  ) { }


  ngOnInit(): void {

    this.getCruce()

    this.store.select(selectUser).subscribe(user => this.user = user);

    this.store.select(selectBtnRapido).subscribe(btnRapido => this.btnRapido = btnRapido);
    console.log(this.btnRapido);
    //nuevo requerimiento
    if (this.btnRapido.id_subtipo == 58) {
      this.toastr.info('Selecciona el tipo de deteccion erronea ', '', { positionClass: 'toast-bottom-right' })
    }

    this.getClasificacionVehicular();
    this.isCaravana = TYPE_CRUCE.EXCENTOS

    // Permisos para retirar o devolucion por roles
    this.store.select(selectPermisos).subscribe(permiso => {
      this.permisos = permiso
    });

  }

  addClasificacion(id: number, clasificacion: string, btn) {
    this.store.dispatch(addCruceClasificacion({ clasificacion: clasificacion, id_clasificacion: id }))
    //redirigir si se aprietan ecc o t+r
    this.gotoEcc(id)
    switch (this.cruce.id_type) {
      case TYPE_CRUCE.INCIDENCIAS:
        console.log('Viene de cruce')
        switch (this.cruce.idPadre) {

          case TYPE_CRUCE_PADRE.ELUDIDOS:
            if (this.toRedirect) {
              this.router.navigate(['/mopa/dinero-eludido']);
            }

            break;
          case TYPE_CRUCE_PADRE.NO_EMITIDOS:
          case TYPE_CRUCE_PADRE.CANCELADOS:
            if (this.toRedirect) {

              if (id == 16 || id == 17) {//RPI , TAG
                this.getCruce()
                this.id_cat_observacion = id == 16 ? 1 : 2
                this.store.dispatch(addCruceObservacion({ id_cat_observacion: this.id_cat_observacion }))
                this.toastr.info('Selecciona el tipo de vehiculo ', '', { positionClass: 'toast-bottom-right' })
                //style del boton
                this.isSelected(btn)
                //validar que solo se selecione uno
                if (this.btnTemp) {
                  this.isSelected(this.btnTemp)
                }
                this.btnTemp = btn;

              } else {
                // Se guarda no emitido o cancelado
                let cruce: Cruce = {
                  fecha_hora: moment().format('YYYY-MM-DD HH:mm:ss'),
                  id_corte_usuario: this.user.id_corte_usuario,
                  id_subtipo: this.cruce.idChildren,
                  id_clasificacion: this.cruce.id_clasificacion,
                  id_cat_observacion: this.id_cat_observacion
                }
                this.store.dispatch(postCruce({ cruce }))
                this.finishEvent()
              }
            }

            break;

        }
        break;
      case TYPE_CRUCE.EXCENTOS:
        if (this.toRedirect) {
          console.log('excentos');
          //incrementar contador caravana
          this.countCaravana++;
          //Se guarda la info del cruce para excentos
          let cruce: Cruce = {
            fecha_hora: moment().format('YYYY-MM-DD HH:mm:ss'),
            id_corte_usuario: this.user.id_corte_usuario,
            id_subtipo: this.cruce.idChildren,
            id_clasificacion: id,
          }
          //obtener suptipo con id_padre para saber si es 5 (VSC)
          let subtipo=(this.cruce.childrens.find(child => child.id == this.cruce.idPadre).childrens).find(child => child.id == this.cruce.idChildren);
          //obtener la Var G para validar
          let variablesG: any[] = JSON.parse(localStorage.getItem('variablesGlobales')+"");
          //si se requiere validacion de JT y si es VSC mandar directo a JT sin importar la cantidad de caravanas
          const valor =Number(variablesG.find(variable => variable.id == 4).valor)
          if(valor === 1 ){
            //enviar directo para confirmacion de JT socket u otra alternativa
            this.ngxService.start();
            let dataForm:any={cruce:cruce, id_usuario: this.user.id_usuario}
            this.solicitudesService.crearSolicitud(dataForm).subscribe((response:any)=>{
              if (Number(response.id)>0) {
                console.log('Solicitud creada con ID:', response.id);
                this.listenSSE(response.id);
              }
            })
            if (!this.activeCaravana) {
              this.returnPage()
            }
            return;
          }
          this.store.dispatch(postCruce({ cruce }))
          this.toastr.success('Cruce guardado con éxito', '', { positionClass: 'toast-bottom-right' })
          if (!this.activeCaravana) {
            this.returnPage()
          }
        }
        break;
      case TYPE_CRUCE.ALARMAS:
        this.router.navigate(['/mopa/no-evento']);
        
        break;
    }

    if (this.btnRapido.id_subtipo) {
      console.log('Viene de btnRapido')
      this.gotoEcc(id)
      if (this.toRedirect) {

        if (id == 16 || id == 17) {//RPI , TAG
          this.id_cat_observacion = id == 16 ? 1 : 2
          this.store.dispatch(addBtnRapidoObservacion({ id_cat_observacion: this.id_cat_observacion }))
          this.toastr.info('Selecciona el tipo de vehiculo ', '', { positionClass: 'toast-bottom-right' })
          //style del boton
          this.isSelected(btn)
          //validar que solo se selecione uno
          if (this.btnTemp) {
            this.isSelected(this.btnTemp)
          }
          this.btnTemp = btn;

        } else {
          //Si viene de botones rápidos
          this.store.dispatch(addBtnRapidoClasificacion({ clasificacion: clasificacion, id_clasificacion: id }))
          const retornoData = JSON.parse(localStorage.getItem('retornosData') || 'null');
          // Se guarda la info de btnRapido
          
          let BtnRapido: BtnRapido = {
            fecha_hora: moment().format('YYYY-MM-DD HH:mm:ss'),
            id_subtipo: this.btnRapido.id_subtipo,
            id_clasificacion: id,
            id_corte_usuario: this.user.id_corte_usuario,
            id_cat_observacion: this.btnRapido.id_cat_observacion,
            id_vehiculo_exe: this.btnRapido.id_vehiculo_exe,
            retorno: retornoData,

          }
          console.log(BtnRapido);

          this.store.dispatch(postBtnRapido({ btnRapido: BtnRapido }))
          //se elimina el cat observacion
          this.store.dispatch(addBtnRapidoObservacion({ id_cat_observacion: null }))
          this.router.navigate(['/mopa',]);
          this.toastr.success('Se registró el evento ' + this.btnRapido.nombreSubtipo, '', { positionClass: 'toast-bottom-right' })
        }
      }




    }

  }

  getCruce() {
    this.store.select(selectCruce).subscribe(cruce => this.cruce = cruce);
    console.log(this.cruce);
  }

  getClasificacionVehicular() {
    this.store.dispatch(loadTipoVehiculo())
    this.tiposVehiculo$ = this.store.select(selectTipoVehiculo)
  }

  returnPage() {
    this.countCaravana = 0
    this.router.navigate(['/mopa'])
  }

  finishEvent() {
    this.toastr.success('Cruce guardado con éxito', '', { positionClass: 'toast-bottom-right' })
    this.router.navigate(['/mopa/home']);
    this.store.dispatch(clearCruce());

  }

  activeCaravanaHandler(btnC) {
    this.activeCaravana = !this.activeCaravana;
    if (!this.activeCaravana) {
      this.returnPage()
    }
    this.countCaravana = 0;
    this.isSelected(btnC);
  }

  gotoEcc(id: number) {
    if (id == 3 || id == 15) {//3 T+R, 15 ECC+
      this.toRedirect = false;
      this.router.navigate(['/mopa/ecc'])
    }
  }


  hiddenButton(btn) {
    if (this.cruce.id_type == TYPE_CRUCE.EXCENTOS || this.cruce.idPadre == TYPE_CRUCE_PADRE.ELUDIDOS || this.btnRapido.id_subtipo == 61 || this.btnRapido.id_subtipo == 63 || this.btnRapido.id_subtipo == 62 || this.btnRapido.id_subtipo == 58 || this.btnRapido.id_subtipo == 60) {
      if (btn.id == 16 || btn.id == 17) {
        return true
      }
    } else {
      return false
    }


  }

  isSelected(btn) {
    if (btn.classList.contains('selected')) {
      btn.classList.remove('selected');
      btn.classList.remove('dark:bg-blue-800');
      btn.classList.remove('bg-blue-800');
      btn.classList.remove('text-white');
      btn.classList.add('dark:bg-transparent');
    } else {
      btn.classList.add('selected');
      btn.classList.add('dark:bg-blue-800');
      btn.classList.add('bg-blue-800');
      btn.classList.add('text-white');
      btn.classList.remove('dark:bg-transparent');

    }
  }

  getSubDeteccion(event,subdec){
    let elementos=document.getElementsByClassName("sub-deteccion")
    for (let index = 0; index < elementos.length; index++) {
      elementos[index].classList.remove("text-white")
      elementos[index].classList.remove("bg-blue-800")
      elementos[index].classList.remove("dark:bg-blue-800")
      elementos[index].classList.remove("selected")
    }

    event.target.classList.add('text-white')
    event.target.classList.add('bg-blue-800')
    event.target.classList.add('dark:bg-blue-800')
    event.target.classList.add('selected')

    this.store.dispatch(addBtnRapidoObservacion({ id_cat_observacion: subdec }))
    this.toastr.info('Selecciona el tipo de vehiculo ', '', { positionClass: 'toast-bottom-right' })
    console.log(subdec);

  }

  listenSSE(id: any) {
    this.solicitudesService.listenSolicitudes(id).subscribe((response:any)=>{

      console.log('Respuesta SSE:', response);

      if (!response.status || response.status === 'pending') {
        this.listenSSE(id)
        return;
      }

      this.ngxService.stop();

      if (response.status === 'approved') {
        this.toastr.success('Aprobado por jefe');
      }

      if (response.status === 'denied') {
        this.toastr.error('Rechazado');
      }
    })
  }


}
